<template>
  <BasePermission
    :permission="permission"
    :model-value="isSelected"
    :disabled="disabled"
    :has-extra-content="true"
    @update:model-value="handleSelectionChange"
  >
    <template #extra-content>
      <div
        v-for="input in permission.extraInputs"
        :key="input.key"
        class="pt-4 flex flex-col gap-2"
      >
        <label class="text-[13px] secondary_color">{{ input.label }}</label>

        <a-select
          v-if="input.type === 'select'"
          :value="extraValues?.[input.key]"
          :show-arrow="true"
          :disabled="disabled"
          option-label-prop="label"
          @change="(value) => handleExtraUpdate(input.key, value)"
          class="email_view_select w-fit"
        >
          <template #suffixIcon>
            <ThemeImage
              :icon="imageNames.BOTTOM_ARROW"
              alt="bottom_white_arrow"
              class="size-4"
            />
          </template>

          <a-select-option
            v-for="(option, index) in input.options"
            :key="option.value + '_email_view_filter' + index"
            :value="option.value"
            :label="option.label"
          >
            <div class="flex gap-2 items-center">
              <ThemeImage
                :icon="imageNames.TICK_GREY"
                alt="check_icon"
                :class="`${extraValues?.[input.key] !== option.value && 'invisible'}`"
              />
              <span class="proxima_nova text_color">{{ option.label }}</span>
            </div>
          </a-select-option>
        </a-select>
      </div>
    </template>
  </BasePermission>
</template>

<script setup>
import BasePermission from "./BasePermission.vue";
import { computed } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  permission: { type: Object, required: true },
  modelValue: { type: Boolean, required: true },
  disabled: { type: Boolean, default: false },
  extraValues: { type: Object, default: () => ({}) },
});

const emit = defineEmits(["update:modelValue", "update:extra"]);

const isSelected = computed(() => props.modelValue);

const handleSelectionChange = (checked) => {
  emit("update:modelValue", checked);
};

const handleExtraUpdate = (key, value) => {
  emit("update:extra", { key: props.permission.key, inputKey: key, value });
};
</script>

<style scoped>
.email_view_select :deep(.ant-select-dropdown) {
  width: 320px !important;
}
</style>
